if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.sectionScope = this.closest('[id^="shopify-section-"]') || document;
        this.nameField = this.getAssociatedField('properties[Nombre]');
        this.numberField = this.getAssociatedField('properties[Número]');
        this.patchFeeVariantId = (this.dataset.patchFeeVariantId || '').trim();
        this.patchFeeLabel = (this.dataset.patchFeeLabel || 'Cargo por patch').trim();

        // 🔵 Escuchar el submit
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        if (this.numberField) {
          this.numberField.addEventListener(
            'input',
            this.onNumberInput.bind(this)
          );
        }
        if (this.nameField) {
          this.nameField.addEventListener(
            'input',
            this.onNameInput.bind(this)
          );
        }

        this.addEventListener('change', this.onPatchSelectionChange.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        setTimeout(() => this.syncPatchSelectedLegendLabels(), 0);
      }

      onPatchSelectionChange(evt) {
        if (!evt || !evt.target) return;
        if (!evt.target.matches || !evt.target.matches('input[data-patch-option-input]')) return;
        this.syncPatchSelectedLegendLabels();
      }

      syncPatchSelectedLegendLabels() {
        const scope = this.closest('[id^="shopify-section-"]') || document;
        const labelNodes = scope.querySelectorAll('[data-patch-selected-label]');
        if (!labelNodes.length) return;

        const selectedByGroup = {};
        const checkedInputs = scope.querySelectorAll('input[data-patch-option-input]:checked');
        checkedInputs.forEach((input) => {
          const groupKey = input.dataset.patchGroupKey || '';
          if (!groupKey) return;
          const raw = input.dataset.patchOptionLabel || input.value || 'Sin Parche';
          const clean = this.sanitizePatchLabel(raw) || String(raw).trim() || 'Sin Parche';
          selectedByGroup[groupKey] = clean;
        });

        labelNodes.forEach((node) => {
          const key = node.dataset.patchSelectedLabel || '';
          const label = selectedByGroup[key] || 'Sin Parche';
          node.textContent = `· ${label}`;
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // ===============================================================
        // 🔵 VALIDACIÓN CAMPOS PERSONALIZACIÓN (Nombre / Número)
        // ===============================================================
        const nameField = this.getAssociatedField('properties[Nombre]');
        const numberField = this.getAssociatedField('properties[Número]');

        if (nameField) {
          const sanitizedName = this.sanitizeNameValue(nameField.value || '');
          if (nameField.value !== sanitizedName) {
            nameField.value = sanitizedName;
          }
        }

        // Si existen los campos (solo aparece en jerseys)
        if (nameField || numberField) {
          const nameVal = nameField ? nameField.value.trim() : '';
          const numberVal = numberField ? numberField.value.trim() : '';

          // Si usuario escribe uno, debe escribir el otro
          const algunoLleno = nameVal || numberVal;

          if (algunoLleno && (!nameVal || !numberVal)) {
            const msg =
              'Para personalizar tu jersey, debes escribir NOMBRE y NÚMERO.';
            this.handleErrorMessage(msg);
            alert(msg);
            return; // ❌ no enviamos
          }

          if (numberVal && !/^\d{1,2}$/.test(numberVal)) {
            const msg =
              'El NÚMERO del jersey debe contener solo 1 o 2 dígitos.';
            this.handleErrorMessage(msg);
            alert(msg);
            return; // ❌ no enviamos
          }
        }
        // ===============================================================

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const selectedPatches = this.getSelectedPatchOptions();
        this.appendPatchProperties(formData, selectedPatches);

        const shouldSubmitWithPatchFee =
          selectedPatches.length > 0 && Boolean(this.patchFeeVariantId);

        let requestPromise;
        if (shouldSubmitWithPatchFee) {
          requestPromise = this.addMainAndPatchFeeTogether(formData, selectedPatches);
        } else {
          if (this.cart) {
            formData.append(
              'sections',
              this.cart
                .getSectionsToRender()
                .map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
          requestPromise = fetch(`${routes.cart_add_url}`, config);
        }

        requestPromise
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (
              this.cart &&
              this.cart.classList.contains('is-empty')
            )
              this.cart.classList.remove('is-empty');
            if (!this.error)
              this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      onNumberInput(evt) {
        const sanitizedValue = evt.target.value.replace(/\D/g, '').slice(0, 2);
        if (evt.target.value !== sanitizedValue) {
          evt.target.value = sanitizedValue;
        }
      }

      onNameInput(evt) {
        const sanitizedValue = this.sanitizeNameValue(evt.target.value);
        if (evt.target.value !== sanitizedValue) {
          evt.target.value = sanitizedValue;
        }
      }

      sanitizeNameValue(value) {
        if (!value) return '';
        return String(value)
          .replace(/[^A-Za-zÀ-ÖØ-öø-ÿÑñ .-]/g, '')
          .slice(0, 15);
      }

      getAssociatedField(propertyName) {
        if (!propertyName) return null;
        const formId = this.form && this.form.id ? this.form.id : '';
        const safeName = String(propertyName).replace(/"/g, '\\"');
        if (formId) {
          const byFormAttr = this.sectionScope.querySelector(
            `[name="${safeName}"][form="${formId}"]`
          );
          if (byFormAttr) return byFormAttr;
        }
        const localMatch = this.querySelector(`[name="${safeName}"]`);
        if (localMatch) return localMatch;
        return this.sectionScope.querySelector(`[name="${safeName}"]`);
      }


      getSelectedPatchOptions() {
        const selected = [];
        const selectedInputs = document.querySelectorAll('[data-patch-option-input]:checked');
        selectedInputs.forEach((input) => {
          const kind = (input.dataset.patchKind || '').toLowerCase();
          if (kind !== 'patch') return;
          const groupLabelRaw = input.dataset.patchGroupLabel || input.dataset.patchGroupKey || 'Patch';
          const optionLabelRaw = input.dataset.patchOptionLabel || input.value || 'Patch';
          selected.push({
            groupKey: input.dataset.patchGroupKey || '',
            groupLabel: this.sanitizePatchLabel(groupLabelRaw) || groupLabelRaw,
            propertyKey: input.dataset.patchGroupPropertyKey || input.dataset.patchGroupKey || 'patch',
            label: this.sanitizePatchLabel(optionLabelRaw) || optionLabelRaw,
          });
        });
        return selected;
      }

      sanitizePatchLabel(value) {
        if (!value) return '';
        return String(value)
          .replace(/[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }

      appendPatchProperties(formData, selectedPatches) {
        if (!selectedPatches || !selectedPatches.length) return;

        selectedPatches.forEach((patch) => {
          const propertyKey = patch.propertyKey || patch.groupKey || patch.groupLabel || 'Patch';
          formData.append(`properties[${propertyKey}]`, patch.label);
        });

        const resumen = selectedPatches
          .map((patch) => `${patch.groupLabel}: ${patch.label}`)
          .join(' | ');
        // Public key for Shopify Functions/cart matching.
        formData.append('properties[Patches]', resumen);
        // Hidden key to keep UI cleaner where possible.
        formData.append('properties[_Patches]', resumen);
      }

      buildPropertiesFromFormData(formData) {
        const properties = {};
        for (const [key, value] of formData.entries()) {
          if (!key.startsWith('properties[') || !key.endsWith(']')) continue;
          const propertyName = key.slice(11, -1);
          properties[propertyName] = String(value);
        }
        return properties;
      }

      addMainAndPatchFeeTogether(formData, selectedPatches) {
        const quantityRaw = Number(formData.get('quantity'));
        const quantity = Number.isFinite(quantityRaw) && quantityRaw > 0 ? quantityRaw : 1;
        const mainVariantIdRaw = Number(formData.get('id'));

        if (!Number.isFinite(mainVariantIdRaw)) {
          const fallbackConfig = fetchConfig('javascript');
          fallbackConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete fallbackConfig.headers['Content-Type'];
          fallbackConfig.body = formData;
          return fetch(`${routes.cart_add_url}`, fallbackConfig);
        }

        const mainProperties = this.buildPropertiesFromFormData(formData);
        const feeProperties = {
          Tipo: this.patchFeeLabel,
          Detalle: selectedPatches.map((patch) => `${patch.groupLabel}: ${patch.label}`).join(' | '),
          _Detalle: selectedPatches.map((patch) => `${patch.groupLabel}: ${patch.label}`).join(' | '),
        };

        const payload = {
          items: [
            {
              id: mainVariantIdRaw,
              quantity,
              properties: mainProperties,
            },
            {
              id: Number(this.patchFeeVariantId),
              quantity: selectedPatches.length * quantity,
              properties: feeProperties,
            },
          ],
        };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        const jsonConfig = fetchConfig('javascript');
        jsonConfig.method = 'POST';
        jsonConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
        jsonConfig.headers['Content-Type'] = 'application/json';
        jsonConfig.body = JSON.stringify(payload);

        const cartAddJsonUrl = `${routes.cart_add_url}.js`.replace('/add.js.js', '/add.js');
        return fetch(cartAddJsonUrl, jsonConfig);
      }

      async addPatchFeeLineIfNeeded(selectedPatches) {
        if (!selectedPatches || !selectedPatches.length) return null;
        if (!this.patchFeeVariantId) return null;
        const quantityInput = this.form ? this.form.querySelector('[name="quantity"]') : null;
        const baseQtyRaw = quantityInput ? Number(quantityInput.value) : 1;
        const baseQty = Number.isFinite(baseQtyRaw) && baseQtyRaw > 0 ? baseQtyRaw : 1;

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const feeFormData = new FormData();
        feeFormData.append('id', this.patchFeeVariantId);
        feeFormData.append('quantity', String(selectedPatches.length * baseQty));
        feeFormData.append('properties[Tipo]', this.patchFeeLabel);
        feeFormData.append(
          'properties[Detalle]',
          selectedPatches.map((patch) => `${patch.groupLabel}: ${patch.label}`).join(' | ')
        );
        feeFormData.append(
          'properties[_Detalle]',
          selectedPatches.map((patch) => `${patch.groupLabel}: ${patch.label}`).join(' | ')
        );

        if (this.cart) {
          feeFormData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );
          feeFormData.append('sections_url', window.location.pathname);
        }

        config.body = feeFormData;
        const res = await fetch(`${routes.cart_add_url}`, config);
        const json = await res.json();
        return json;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
